import { IconButton, styled, Tooltip } from '@mui/material'
import { type Icon, Info, Warning } from '@phosphor-icons/react'
import { tokens } from 'ComponentLibrary'
import { CSSProperties } from 'react'

type IconTooltipProps = {
    Icon: Icon
    iconColor?: string
    iconStyle?: CSSProperties
} & BaseTooltipProps

type BaseTooltipProps = {
    text: React.ReactNode
    size?: `${number}px`
    weight?: 'bold' | 'regular'
    style?: CSSProperties
}

export function InfoTooltip({ text, style, weight, size = '16px' }: BaseTooltipProps) {
    return <IconTooltip text={text} size={size} weight={weight} Icon={Info} iconColor={tokens.ColorIconSubtlest} style={style} />
}

export function WarningTooltip({ text, style, size = '16px' }: BaseTooltipProps) {
    return <IconTooltip text={text} size={size} Icon={Warning} iconColor={tokens.ColorIconWarning} style={style} />
}

function IconTooltip({ text, size = '16px', weight = 'bold', Icon, iconColor, iconStyle, style }: IconTooltipProps) {
    return (
        <Tooltip
            title={text}
            placement="top"
            onClick={(event) => event.stopPropagation()}
            style={style}
            componentsProps={{
                popper: {
                    sx: { zIndex: 1999 },
                },
            }}
        >
            <StyledIconButton>
                <Icon size={size} style={iconStyle} weight={weight} color={iconColor} />
            </StyledIconButton>
        </Tooltip>
    )
}

const StyledIconButton = styled(IconButton)(() => ({
    padding: tokens.SizingSpacing050,
    borderRadius: '50%',
    transition: 'background-color 0.2s ease-in-out',
    cursor: 'default',
    '&:hover': {
        color: tokens.ColorIconSubtlest,
        backgroundColor: tokens.ColorSurfaceHover,
    },
}))
